import { render } from "./t-confirm.vue?vue&type=template&id=3951a6bb&scoped=true"
import script from "./t-confirm.vue?vue&type=script&lang=js"
export * from "./t-confirm.vue?vue&type=script&lang=js"

import "./t-confirm.vue?vue&type=style&index=0&id=3951a6bb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3951a6bb"]])

export default __exports__